

































































import type { PropType } from '@vue/composition-api';
import { defineComponent, computed, ref } from '@vue/composition-api';
import type { DsrDirectory } from '@getaccept/lib-shared/src/library/types/dsr-directory';
import type { DsrResource } from '@getaccept/lib-shared/src/library/types/dsr-resource';
import LoaderRow from '@getaccept/lib-shared/src/table/LoaderRow.vue';
import EmptyStateRow from '@getaccept/lib-shared/src/table/EmptyStateRow.vue';
import DirectoryRow from '@getaccept/lib-shared/src/library/components/DirectoryRow.vue';
import { SortOrder } from '@getaccept/lib-shared/src/enums/sort-order';
import { useIntersectionObserver } from '@vueuse/core';
import { DsrSortAttribute } from '../api/dsr/types/enums/dsr-sort-attribute';
import TemplateRow from './TemplateRow.vue';

export default defineComponent({
  name: 'TemplateTable',
  components: {
    LoaderRow,
    EmptyStateRow,
    DirectoryRow,
    TemplateRow,
  },
  props: {
    templates: {
      type: Array as PropType<DsrResource[]>,
      required: true,
    },
    directories: {
      type: Array as PropType<DsrDirectory[]>,
      required: true,
    },
    sortOrder: {
      type: String as PropType<SortOrder>,
      required: true,
    },
    sortBy: {
      type: String as PropType<DsrSortAttribute>,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    error: {
      type: Boolean,
    },
    hasNextPage: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const showEmptyState = computed(
      () => props.error || (!props.templates.length && !props.directories.length)
    );

    const isSortingBy = (key: DsrSortAttribute) => key === props.sortBy;

    const handleSort = (sortBy: DsrSortAttribute) => {
      const isActiveSortBy = props.sortBy === sortBy;
      const toggledSortOrder = props.sortOrder === SortOrder.Asc ? SortOrder.Desc : SortOrder.Asc;
      const sortPayload = { sortBy, sortOrder: isActiveSortBy ? toggledSortOrder : SortOrder.Desc };
      emit('sort', sortPayload);
    };

    const loadMoreRow = ref<HTMLTableRowElement | null>(null);

    useIntersectionObserver(
      loadMoreRow,
      ([{ isIntersecting }]) => {
        if (!isIntersecting || !props.hasNextPage) {
          return;
        }
        emit('fetch-more-templates');
      },
      { threshold: 0 }
    );

    return {
      DsrSortAttribute,
      showEmptyState,
      isSortingBy,
      handleSort,
      loadMoreRow,
    };
  },
});
